import React from "react";
import NextImage from "next/image";
import classnames from "classnames";
import SbEditable from "storyblok-react";
import { basicLoader } from "@/helpers/utils";
import Button from "@/components/Button/button";
import styles from "./pricing-consultation-banner.module.scss";
import type { PricingConsultationBannerStoryblok } from "./types";

interface Props {
  blok: PricingConsultationBannerStoryblok;
}

const PricingConsultationBanner = ({ blok }: Props) => {
  const isGradient = blok.variant === "gradient";

  return (
    // @ts-expect-error
    <SbEditable content={blok}>
      <div
        className={classnames(styles.banner, {
          [styles.bannerGradient]: isGradient,
        })}
      >
        {blok.image?.filename ? (
          <div
            className={classnames(styles.imageWrap, {
              [styles.imageWrapGradient]: isGradient,
            })}
          >
            <NextImage
              src={blok.image.filename}
              alt={isGradient ? "" : blok.image.alt || ""}
              fill
              style={{ objectFit: "cover" }}
              loader={basicLoader}
              sizes={isGradient ? "100vw" : "(min-width: 1024px) 182px, 100vw"}
            />
          </div>
        ) : null}
        <div className={styles.content}>
          {blok.heading ? (
            <h2 className={styles.heading}>{blok.heading}</h2>
          ) : null}
          {blok.body ? <p className={styles.body}>{blok.body}</p> : null}
          {blok.cta_link ? (
            <Button
              link={blok.cta_link}
              accent_color={isGradient ? undefined : "accentPink"}
              btnStyle={isGradient ? "white" : undefined}
              size="medium"
            >
              {blok.cta_text || "Schedule a free consultation"}
            </Button>
          ) : null}
        </div>
      </div>
    </SbEditable>
  );
};

export default PricingConsultationBanner;
